module.exports = __webpack_public_path__ + "static/media/GWC 24 Digital Agenda Winners Header.ad95f5fb.jpg";